// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__SzTkT","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3fN5_","gfeWrapper":"CalendarEvent_gfeWrapper__2n2Qk"};